import { render, staticRenderFns } from "./AnuladosList.vue?vue&type=template&id=4bf0f6fa&scoped=true&"
import script from "./AnuladosList.vue?vue&type=script&lang=js&"
export * from "./AnuladosList.vue?vue&type=script&lang=js&"
import style0 from "./List/styles.scss?vue&type=style&index=0&id=4bf0f6fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf0f6fa",
  null
  
)

export default component.exports